module.exports = __webpack_public_path__ + "static/media/YM84_3.15cd012b.jpg";